import { Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import Albums from './pages/Albums'
import AlbumPhotos from './pages/AlbumPhotos'
import PhotoDetail from './pages/PhotoDetail'
import About from './pages/About'
import Admin from './pages/Admin'
import NotFound from './pages/NotFound'
import AppErrorBoundary from './components/AppErrorBoundary'

function App() {
    return (
        <div className="font-inter antialiased bg-gradient-to-r from-gray-950 via-gray-900 to-gray-950 text-gray-100">
            <AppErrorBoundary>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/albums" element={<Albums />} />
                    <Route path="/albums/:albumId/photos" element={<AlbumPhotos />} />
                    <Route path="/albums/:albumId/photos/:photoId" element={<PhotoDetail />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </AppErrorBoundary>
        </div>
    )
}

export default App
